module.exports = __webpack_public_path__ + "img/fast.c09e9598.svg";